import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailImageAssetDirective } from '../../directives/email-image-asset.directive';
import { EmailMailgunEachDirective } from '../../directives/email-mailgun-each.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';
import { MailgunRelativePathPipe } from '../../pipes/mailgun-relative-path.pipe';
import { EmailLinkComponent } from '../email-link/email-link.component';
import { EmailMarginComponent } from '../email-margin/email-margin.component';
import { EmailTextComponent } from '../email-text/email-text.component';

export interface DailyReport {
  title: string;
  url: string;
  candidates: DailyReportItem[];
}

export interface DailyReportItem {
  avatar_url: string;
  url: string;
  name: string;
  stage: string;
}

@Component({
  selector: 'email-candidates-reports',
  styleUrls: ['./email-candidates-reports.component.less'],
  template: `
    <ng-container *mailgunFor="let report of reports">
      <table cellspacing="0" cellpadding="0" class="daily-report">
        <tr>
          <td colspan="2">
            <table cellspacing="0" cellpadding="0">
              <tr>
                <th class="head-cell" align="left">
                  <email-text [contents]="report.title" presetName="header" size="small" />
                </th>
                <th class="head-cell" width="4"></th>
                <th class="head-cell head-link-cell" align="right">
                  <email-link
                    [href]="report.url"
                    [label]="headerLinkLabel | mailgunRelativePath"
                    [textOpts]="{ size: 'small' }"
                  />
                </th>
              </tr>
            </table>
            <email-margin [height]="12" />
          </td>
        </tr>

        <ng-container *mailgunFor="let candidate of report.candidates">
          <tr>
            <td class="report-cell" align="left">
              <table cellspacing="0" cellpadding="0">
                <tr>
                  <td width="36">
                    <div class="avatar">
                      <img
                        class="avatar"
                        width="36"
                        height="36"
                        [attr.src]="candidate.avatar_url.toJSON()"
                        [alt]="candidate.name.toJSON()"
                      />
                    </div>
                  </td>
                  <td width="12">&nbsp;</td>
                  <td>
                    <email-text [contents]="candidate.name" className="report-candidate-name" />
                    <email-margin [height]="4" />
                    <email-text [contents]="candidate.stage" className="report-candidate-stage" />
                  </td>
                </tr>
              </table>
            </td>
            <td class="report-cell" align="right">
              <a [href]="candidate.url.toJSON()"
                ><img
                  [src]="'assets/open-in-new.png'"
                  width="36"
                  height="36"
                  [alt]="candidate.name.toJSON()"
              /></a>
            </td>
          </tr>
        </ng-container>
      </table>
      <email-margin [height]="18" />
    </ng-container>
  `,
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
  imports: [
    EmailImageAssetDirective,
    MailgunRelativePathPipe,
    EmailMarginComponent,
    EmailTextComponent,
    EmailLinkComponent,
    EmailMailgunEachDirective,
    EmailMailgunEachDirective,
  ],
})
export class EmailCandidatesReportsComponent {
  @Input() public reports: WrappedValue<DailyReport[]>;
  @Input() public headerLinkLabel: WrappedValue<string>;
}
